/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { mergeListById } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import HeartRateFilter from "../Popup/HeartRateFilter";
import SaveHeartRatePopup from "components/Common/Popup/SaveHeartRatePopup";

const HeartRate = ({ patientObj = null }) => {
  const { t } = useTranslation();
  const params = useParams();

  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [heartRateList, setHeartRateList] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [selectedHeartRateIds, setSelectedHeartRateIds] = useState([]);
  const [selectedHeartRateId, setSelectedHeartRateId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //get all heart rate
  const getAllHeartRate = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_HEART_RATE +
        `?token=${token}&userids=${params.id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log(
        "requestUrl in get all heart rate in patient details",
        requestUrl
      );

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        const { listrecords } = response.data;
        setHeartRateList(listrecords);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //update heart rate
  const updateBulkHeartRateHandler = async () => {
    if (selectedHeartRateIds.length > 0) {
      try {
        const heartRateListToBeUpdate = heartRateList.filter((item) =>
          selectedHeartRateIds.includes(item._id)
        );

        let heartRateData = {
          heartratelist: heartRateListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_HEART_RATE + `?token=${token}`;

        const response = await putData(requestURL, heartRateData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedHeartRateIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one heart rate");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //delete heart rate
  const deleteBulkHeartRateHandler = async () => {
    if (selectedHeartRateIds.length > 0) {
      try {
        const heartRateListToBeDelete = heartRateList.filter((item) =>
          selectedHeartRateIds.includes(item._id)
        );

        let heartRateData = {
          heartratelist: heartRateListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_HEART_RATE + `?token=${token}`;

        const response = await putData(requestURL, heartRateData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setHeartRateList((prevList) =>
              prevList.filter(
                (item) => !selectedHeartRateIds.includes(item._id)
              )
            );

            setSelectedHeartRateIds([]);
            setRowSelection({});
          }, 1500);
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one heart rate");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const afterActionClose = (data = []) => {
    setHeartRateList((prevList) => mergeListById(prevList, data));
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
    setRowSelection({});
    setSelectedHeartRateIds([]);
  };

  // useEffect(() => {
  //   getAllHeartRate();
  // }, []);

  useEffect(() => {
    if (reloadData) {
      getAllHeartRate();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllHeartRate();
    }
  }, [jsonFilterQuery]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveHeartRateOffCanvas"
            aria-controls="saveHeartRateOffCanvas"
            onClick={() => {
              setSelectedHeartRateId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Heart Rate (bpm)",
        accessorKey: "bpm",
        size: 200,
      },
      {
        header: "Date",
        accessorKey: "date",
        size: 200,
        Cell: ({ cell }) => {
          const dateValue = cell.getValue();
          if (dateValue) {
            const date = new Date(dateValue);
            return date.toLocaleDateString();
          }
          return "";
        },
      },
      {
        header: "Assigned To",
        accessorKey: "username",
        size: 300,
        Cell: ({ row }) => (
          <div
            className={
              row.original.username === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.userimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.userimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.username}</span>
            </p>
          </div>
        ),
      },
    ],
    []
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedHeartRateIds(selectedIdsArray);
  }, [rowSelection]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center mb-4">
          <div className="col-lg-4">
            <h3 className="mb-0">Heart Rate</h3>
          </div>
          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>
            {/* <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-gray text-start w-100 dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
              >
                Action
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm fw-semibold border-0 rounded-10 shadow-sm">
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-1 ${
                      selectedHeartRateIds.length === 0
                        ? "disabled text-muted"
                        : ""
                    }`}
                    onClick={() => {
                      if (selectedHeartRateIds.length > 0) {
                        updateBulkHeartRateHandler();
                      }
                    }}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      progress_activity
                    </span>
                    <span className="d-block">Update</span>
                  </Link>
                </li>
                <hr className="dropdown-divider" />
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-1 ${
                      selectedHeartRateIds.length === 0
                        ? "disabled text-muted"
                        : "text-danger"
                    }`}
                    data-bs-toggle="modal"
                    data-bs-target="#deletewarning"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      delete
                    </span>
                    <span className="d-block">Delete</span>
                  </Link>
                </li>
              </ul>
            </div> */}
            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#heartRateFilterOffCanvas"
              aria-controls="heartRateFilterOffCanvas"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#saveHeartRateOffCanvas"
              aria-controls="saveHeartRateOffCanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>

      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={heartRateList}
            enableGrouping // to enable grouping of column
            enableRowSelection // enable showing checkbox in each row
            getRowId={(row) => row._id}
            onRowSelectionChange={setRowSelection}
            state={{ rowSelection, columnOrder }}
            initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50, //make columns wider by default
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      {/* modal and popup section  */}

      <SaveHeartRatePopup
        patientObj={patientObj}
        selectedHeartRateId={selectedHeartRateId}
        setSelectedHeartRateId={setSelectedHeartRateId}
        afterActionClose={afterActionClose}
      />

      <DeleteWarningModal
        onDelete={deleteBulkHeartRateHandler}
        onCancelDelete={() => {
          setRowSelection({});
          setSelectedHeartRateIds([]);
        }}
        moduleName={t("heart rate")}
      />

      <HeartRateFilter
        moduleSlug="heartratepatient"
        jsonFilterQuery={jsonFilterQuery}
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={resetFilterData}
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={() => {
            setShowAlert(false);
            setAlertMessage("");
            setMessageType("");
          }}
        />
      )}
    </div>
  );
};

export default HeartRate;
